import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Title, ItemText, ItemRescription, ItemTitle, Icon, IconImg, Item, List } from './styled';

class Promo extends React.PureComponent {
    render() {

        const { pageContent, columns = 3, children, isVillage } = this.props;

        let title = pageContent.titleClients;
        let clientsArray = pageContent.clients;

        if (isVillage) {
            title = pageContent.titleClientsVillage;
            clientsArray = pageContent.clientsVillage;
        }

        return (
            <Wrapper>
                <Title >{title}</Title>
                { children }
                <List>
                    {
                        clientsArray.map((element) => (
                            <Item key={element.title} columns={columns}>
                                <Icon>
                                    <IconImg src={`../../../../static/images/icons/${element.images}`} alt='' />
                                </Icon>
                                <ItemText>
                                    { element.title && <ItemTitle>{element.title}</ItemTitle> }
                                    <ItemRescription>{element.text}</ItemRescription>
                                </ItemText>
                            </Item>
                        ))
                    }
                </List>
            </Wrapper>
        );
    }
}

Promo.propTypes = {
    pageContent: PropTypes.object,
    columns: PropTypes.number
};

export default Promo;
